import { handleActions } from "redux-actions"
import produce from "immer"
import lodash from "lodash"
import { toast } from "react-toastify"

import {
  REQUEST_CREATE,
  RECEIVE_CREATE,
  REQUEST_UPDATE,
  RECEIVE_UPDATE,
  REQUEST_DELETE,
  RECEIVE_DELETE,
  REQUEST_IMPORT,
  RECEIVE_IMPORT,
  SET
} from "./constants"

const initialState = {
  isOpen: false,
  isLoading: false,
  error: undefined,
  result: undefined,
  address: undefined,
  isDelete: false,
  isImport: false,
  isQuick: false
}

const handleSet = produce((draft, { payload }) => {
  lodash.forOwn(payload, (value, key, object) => lodash.set(draft, key, value))
})

const handleRequest = produce((draft, { payload }) => {
  draft.isLoading = true
  draft.result = undefined
  draft.error = undefined
})

const handleReceive = produce((draft, { payload: { result, error } }) => {
  draft.isLoading = false
  draft.result = result
  draft.error = error
})

export default handleActions(
  {
    [SET]: handleSet,
    [REQUEST_CREATE]: handleRequest,
    [RECEIVE_CREATE]: handleReceive,
    [REQUEST_UPDATE]: handleRequest,
    [RECEIVE_UPDATE]: handleReceive,
    [REQUEST_DELETE]: handleRequest,
    [RECEIVE_DELETE]: handleReceive,
    [REQUEST_IMPORT]: handleRequest,
    [RECEIVE_IMPORT]: handleReceive
  },
  initialState
)
